import { useGetLicensesQuery } from '@/core/services/license'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { useAppSelector } from '@/redux/rootReducer'
import { isStaff } from '@/utils/type-guards'

const INS_IDENTITY_VIGILANCE_POLICY_NAME = 'InsIdentityVigilance'

export function useIsIdentityVigilanceOfficer(): boolean {
  const authUser = useAppSelector(selectAuthUser)
  const skip = !isStaff(authUser) || !authUser?.licenses?.length

  const { data: licenses } = useGetLicensesQuery({ id: authUser?.licenses ?? [] }, { skip })

  if (!isStaff(authUser)) return false

  return licenses?.some((license) => license.policies?.some((policy) => policy.name === INS_IDENTITY_VIGILANCE_POLICY_NAME)) ?? false
}
